var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showNewVersion
    ? _c(
        "header",
        {
          staticClass: "overview-header",
          attrs: { "data-bot": "overview__header" }
        },
        [
          _c(
            "div",
            { staticClass: "overview-header__backlink" },
            [
              _c("CompassBackForwardButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.back"),
                  link: "javascript:history.back();",
                  type: "secondary",
                  size: "small",
                  back: ""
                }
              }),
              _vm._v(" "),
              _c("OverviewNav", {
                staticClass: "flex-right",
                attrs: {
                  overviewhash: _vm.overviewhash,
                  identity: _vm.identity,
                  splitter: _vm.splitter,
                  "use-s-p-a-routing": true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overview-header__wrapper" }, [
            _c(
              "div",
              { staticClass: "overview-header__title-and-tags" },
              [
                _c(
                  "EditText",
                  {
                    staticClass: "overview-header__title",
                    attrs: {
                      text: _vm.name,
                      canEdit: _vm.canEditName,
                      loading: _vm.isLoadingTitle,
                      contentTypographyClass: "typographies-heading-h1"
                    },
                    on: { update: _vm.handleTitleUpdate }
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "overview-header__title-content typographies-heading-h1"
                      },
                      [
                        _c(
                          "span",
                          { attrs: { "data-bot": "overview__header--name" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.name) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.newTagsThird.length > 0
                  ? _c(
                      "div",
                      { staticClass: "overview-header__third-tags" },
                      _vm._l(_vm.newTagsThird, function(tag, index) {
                        return _c(
                          "TagThird",
                          {
                            key: index,
                            attrs: {
                              type: tag.type,
                              size: "extra-small",
                              "data-bot":
                                "overview__header--label-" + (index + 1)
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(tag.label) +
                                "\n                "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("tags", {
                  attrs: {
                    linkedtype: _vm.linkedtype,
                    linkedid: _vm.linkedid,
                    permissions: _vm.permissionsTag,
                    options: _vm.tags,
                    display: "inline"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function() {
                          return [_c("span")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4221130372
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "overview-header__stats-and-actions" }, [
              _c(
                "div",
                { staticClass: "overview-header__stats-and-avatar" },
                [
                  _vm.isClient
                    ? _c(
                        "div",
                        {
                          staticClass: "overview-header__stats",
                          attrs: {
                            "data-bot": "overview__header--total-turnover"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: { name: "third.overview.statistics" }
                              }
                            },
                            [
                              _c("fiscal-statistics-header", {
                                attrs: {
                                  linkedtype: _vm.linkedtype,
                                  linkedid: _vm.linkedid
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "CompassFormItem",
                    {
                      attrs: {
                        size: "small",
                        label: _vm.$t.__("common.labels.owner")
                      }
                    },
                    [
                      _c("EditOwner", {
                        attrs: {
                          data: [_vm.owner],
                          canEdit: _vm.hasAccess("can_edit", _vm.permissions),
                          multiple: false,
                          loading: _vm.isLoadingOwner
                        },
                        on: { update: _vm.handleOwnerUpdate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "overview-header__actions" },
                [
                  _c(
                    "CompassMenu",
                    {
                      attrs: {
                        placement: "bottom-end",
                        customClass: "overview-header__actions-menu"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dropdown",
                            fn: function() {
                              return _vm._l(_vm.mapActions, function(
                                action,
                                index
                              ) {
                                return _c("CompassMenuItem", {
                                  key: index,
                                  attrs: {
                                    disabled: !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    ),
                                    label: action.label
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleActionItemClick(action)
                                    }
                                  }
                                })
                              })
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1590787880
                      )
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: {
                          icon: "action",
                          "data-bot": "overview-header__actions-button"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showCreateMenu
                    ? _c(
                        "CompassMenu",
                        {
                          attrs: {
                            placement: "bottom-end",
                            customClass: "overview-header__create-menu"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "dropdown",
                                fn: function() {
                                  return _vm._l(
                                    _vm.allowedCreateActions,
                                    function(action, index) {
                                      return _c("CompassMenuItem", {
                                        key: index,
                                        attrs: { label: action.label },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleCreate(action.type)
                                          }
                                        }
                                      })
                                    }
                                  )
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            4263235400
                          )
                        },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("common.actions.create"),
                              type: "secondary",
                              size: "small",
                              dropdown: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "CompassMenu",
                    {
                      attrs: {
                        placement: "bottom-end",
                        customClass: "overview-header__schedule-menu"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dropdown",
                            fn: function() {
                              return _vm._l(
                                _vm.allowedScheduledActions,
                                function(action, index) {
                                  return _c(
                                    "CompassMenuItem",
                                    {
                                      key: index,
                                      on: {
                                        click: function($event) {
                                          return _vm.handleClick(action.type)
                                        }
                                      }
                                    },
                                    [
                                      _c("CompassObject", {
                                        attrs: {
                                          object: action.icon,
                                          size: "extra-small"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(action.label))])
                                    ],
                                    1
                                  )
                                }
                              )
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2798618763
                      )
                    },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.schedule"),
                          size: "small",
                          type: "secondary",
                          dropdown: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    : _c(
        "header",
        {
          staticClass: "white-bkg bb-1 px-5 py-3 mt--5 ml--5",
          attrs: { "data-bot": "overview__header" }
        },
        [
          _c("div", { staticClass: "flex-level m-auto pb-3" }, [
            _c(
              "div",
              { staticClass: "identity flex-level no-shrink flex-top wp-10" },
              [
                _c("avatar", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.avatar.type == "picture",
                      expression: "avatar.type == 'picture'"
                    }
                  ],
                  attrs: {
                    avatar: _vm.avatar,
                    size: "xxbig",
                    editable: _vm.hasAccess("can_edit", _vm.permissions),
                    route: _vm.avatarRoute
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "wp-10",
                    class: { "ml-3": _vm.avatar.type == "picture" }
                  },
                  [
                    _c("h2", { staticClass: "mt-0 mb-1 ellipsis" }, [
                      _c(
                        "span",
                        { staticClass: "flex-level" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.name,
                                placement: "top"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    "data-bot": "overview__header--name"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.name) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.tagsThirdtype, function(tagThird, index) {
                            return _c(
                              "TagThird",
                              {
                                key: index,
                                staticClass: "tag-third",
                                attrs: {
                                  type: tagThird.type,
                                  size: "extra-small",
                                  "data-bot":
                                    "overview__header--label-" + (index + 1)
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(tagThird.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("tags", {
                      staticClass:
                        "flex-row flex-right m-0 flex-row-reverse ai-center tags-350",
                      attrs: {
                        linkedtype: _vm.linkedtype,
                        linkedid: _vm.linkedid,
                        permissions: _vm.permissionsTag,
                        options: _vm.tags,
                        display: "inline"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function() {
                            return [_c("span")]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isClient
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-item-right aright header-statistics",
                        attrs: {
                          "data-bot": "overview__header--total-turnover"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "gray-100",
                            attrs: { to: { name: "third.overview.statistics" } }
                          },
                          [
                            _c("fiscal-statistics-header", {
                              attrs: {
                                linkedtype: _vm.linkedtype,
                                linkedid: _vm.linkedid
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-level m-auto pt-2 bt-1" }, [
            _c(
              "div",
              { staticClass: "main-infos flex-row flex fw-wrap" },
              _vm._l(_vm.favorites, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "data-block pl-0" },
                  [
                    _c(
                      item.format + "-data",
                      _vm._b(
                        {
                          tag: "component",
                          attrs: { canRemoveFavorite: true },
                          on: {
                            toggleFavorite: function($event) {
                              return _vm.updateFavorites(item)
                            }
                          }
                        },
                        "component",
                        item,
                        false
                      )
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-right" },
              [
                _c(
                  "el-dropdown",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "dropdown",
                        fn: function() {
                          return [
                            _c(
                              "el-dropdown-menu",
                              _vm._l(_vm.mapActions, function(action, index) {
                                return _c(
                                  "el-dropdown-item",
                                  {
                                    key: index,
                                    attrs: {
                                      disabled: !_vm.hasAccess(
                                        action.permission,
                                        _vm.permissions
                                      )
                                    }
                                  },
                                  [
                                    action.type == "function"
                                      ? _c(
                                          "a",
                                          {
                                            class: !_vm.hasAccess(
                                              action.permission,
                                              _vm.permissions
                                            )
                                              ? "link-disabled"
                                              : "",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleFunctionCall(
                                                  action.value
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(action.label) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      : action.type == "vuejs"
                                      ? _c(
                                          "a",
                                          {
                                            class: !_vm.hasAccess(
                                              action.permission,
                                              _vm.permissions
                                            )
                                              ? "link-disabled"
                                              : "",
                                            attrs: {
                                              onclick: _vm.buildUrl(
                                                action.value,
                                                _vm.parameters
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(action.label) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "a",
                                          {
                                            class: !_vm.hasAccess(
                                              action.permission,
                                              _vm.permissions
                                            )
                                              ? "link-disabled"
                                              : "",
                                            attrs: {
                                              href: _vm.buildUrl(
                                                action.value,
                                                _vm.parameters
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(action.label) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              }),
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.labels.actions"),
                        type: "secondary",
                        dropdown: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }